// Decode UTF-8 language characters once, only at the presentation boundary.
// Keep ASCII URL delimiters, escapes, controls and markdown syntax encoded.
export const decodeDisplayText = value => {
    if (typeof value !== 'string') return value;
    return value.replace(/(?:%(?:C[2-9A-F]|D[0-9A-F])%[89AB][0-9A-F]|%E[0-9A-F](?:%[89AB][0-9A-F]){2}|%F[0-4](?:%[89AB][0-9A-F]){3})+/gi, encoded => {
        try {
            return decodeURIComponent(encoded);
        } catch {
            return encoded;
        }
    });
};

// A bare URL used as a preview title is more useful as its final path label.
export const getUrlDisplayTitle = value => {
    if (typeof value !== 'string') return value;
    if (/^https?:\/\/\S+$/i.test(value.trim())) {
        try {
            const url = new URL(value.trim());
            const filename = url.pathname.split('/').filter(Boolean).pop();
            if (filename) return decodeDisplayText(filename).replace(/%20/gi, ' ').replace(/_/g, ' ');
            return decodeDisplayText(url.hostname);
        } catch {
            // Malformed URLs still have a safe display fallback.
        }
    }
    // Markdown destinations must stay encoded until after parsing.
    if (/\[[^\]]*\]|<[^>]+>|`/.test(value) || /https?:\/\//i.test(value)) return value;
    return decodeDisplayText(value);
};
